<template>
    <div>
        <AuthPopup
            v-if="showAuthPopup"
            :webview-redirect-to="createWebviewRedirectTo()"
            :show-close-button="false"
            @login-success="loginSuccess"
            @register-success="loginSuccess" />
    </div>
</template>

<script>
import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'
import UserService from '@/lib/user'
import AuthPopup from '@/components/AuthPopup'
import AuthPopupMixin from '@/mixins/auth-popup'

export default {

    mixins: [AuthPopupMixin],

    components: {
        AuthPopup
    },

    mounted: function() {

        const userService = new UserService

         userService.validateToken().then(() => {
            this.afterLoginSuccess()
        })
        .catch(() => {
            this.showAuthPopup = true
        })
    },

    methods: {

        afterLoginSuccess () {
            const self = this
            const request = new Request()
            const { id } = this.$route.params
            const userService = new UserService()
            const url = appConfig.api.playTogether.replace('__id__', id) + '?id=' + userService.getUser().id

            this.$store.commit('toggleMainLoader', true)
            this.$store.commit('masterQuizId', id)

            request.get(url)
                .then (function (res) {
                    let id = res.data.data.quizId

                    const mode = new URL(window.location.href).searchParams.get('mode');

                    if (mode && mode == 'preview') {
                        res.data.data.inactive_quiz = false
                    }

                    if (res.data.data.inactive_quiz) {
                        window.location.href = '/'
                        return
                    }

                    self.$store.commit('setParentQuizCode', res.data.data.parent_quiz_code)
                    self.$router.push({
                        path: `/edit/${id}`,
                        query: {
                            type: 'pt',
                            mode: mode && mode == 'preview' ? mode : undefined
                        }
                    })
                })
                .catch (function () {
                    window.location.href = '/'
                })
        }
    }
}
</script>
